<template>
  <div class="container">
    <div class="row">
      <div class="col">
        <div class="btn-group btn-block">
          <template v-for="(l, i) in links">
            <router-link
              :key="i"
              class="btn btn-light btn-sm"
              :to="l[0]"
              v-if="$store.state.config.dinner && menu && l[2] && menu[l[2]]"
              >{{ l[1] }}</router-link
            >
          </template>
          <a
            class="btn btn-light btn-sm"
            href="javascript:void(0)"
            @click.prevent="logout()"
            title="Cerrar Sesion"
          >
            <i class="fas fa-sign-out-alt mr-1"></i>
            <span class="d-none d-lg-inline">Cerrar session</span>
          </a>
        </div>
      </div>
    </div>
    <router-view></router-view>
    <small>v1.2</small>
  </div>
</template>
<script>
import { mapState } from "vuex";

export default {
  components: {
    //
  },

  // directives
  // filters

  props: {
    //
  },

  data: () => ({
    links: [
      ["/store", "Vender", "store"],
      ["/diaries", "Diario", "diaries"],
      ["/admin/my-cashregister", "Caja", "box"],
      ["/admin/cashregisters", "Registros", "boxes"],
      ["/sales", "Ventas", "sales"],
      ["/products", "Productos", "products"],
      ["/report", "Reporte", "report"],
      ["/clients", "Clientes", "clients"],
      ["/permissions", "Permisos", "permissions"],
      ["/to-make", "Por realizar", "to-make"],
      ["/maked", "Realizado", "maked"]
    ]
  }),

  computed: {
    ...mapState({
      menu: (s) => s.config.dinner.client.menu
    })
  },

  watch: {
    //
  },

  mounted() {
    //
  },

  methods: {
    logout() {
      sessionStorage.clear();
      localStorage.clear();
      location.reload();
    },
  },
};
</script>

<style scoped></style>
